import Form from 'antd/es/form';

Form.defaultProps.colon = false;
Form.defaultProps.hideRequiredMark = true;
